module.exports = __webpack_public_path__ + "static/img/fuwu4.8ae053b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu4.png
// module id = HNa7
// module chunks = 1